<div
  class="growth-revision-filter-holder"
  [ngClass]="{
    'data-review-filter--active': dataViewFilterVisible,
    'growth-revision-filter--disable': disabled
  }"
>
  <label class="filter-label">Growth/Revisions</label>
  <button
    nz-button
    nz-popover
    nzPopoverTrigger="click"
    [nzPopoverContent]="contentTemplate"
    nzPopoverPlacement="bottomLeft"
    [(nzPopoverVisible)]="dataViewFilterVisible"
    (nzPopoverVisibleChange)="popoverChange()"
    class="filter-btn"
    style="width: 100%; height: 25px; padding-left: 0px"
  >
    <span [innerHTML]="selectedDataView"></span>
    <span></span>
    <i nz-icon [nzType]="popoverOpen ? 'up' : 'down'" class="arrow"></i>
  </button>

  <ng-template #contentTemplate>
    <ul nz-menu class="list-style">
      <div class="growth" *ngIf="growthOptions">
        <label class="header-text">Growth:</label>
        <li nz-menu-item>
          <nz-checkbox-group
            [(ngModel)]="growthOptions"
            (ngModelChange)="chkboxOptChange()"
          ></nz-checkbox-group>
        </li>
      </div>
      <li nz-menu-divider style="background-color: #d8d8d8"></li>
      <div class="revision" *ngIf="revisionOptions">
        <label class="header-text">Revisions:</label>
        <div>
          <li nz-menu-item class="revision-radio-container">
            <nz-radio-group
              [(ngModel)]="radioValue"
              class="radio"
              (ngModelChange)="radioValChange()"
              *ngFor="let option of revisionOptions"
            >
              <label
                nz-radio
                [nzValue]="option.value"
                class="radio-opt"
                *ngIf="option.value !== 'custom'"
                >&Delta; {{ option.label }}</label
              >
              <label
                nz-radio
                nzValue="custom"
                class="radio-opt"
                *ngIf="option.value === 'custom'"
              >
                <span>
                  &Delta;
                  <nz-date-picker
                    [(ngModel)]="customDate"
                    [nzDisabledDate]="disabledCustomDate"
                    (ngModelChange)="onDateChange()"
                    nzPlaceHolder="Custom"
                    class="date-picker"
                    [ngStyle]="{
                      border: 'none',
                      'border-bottom': inValidCustomDate
                        ? '1px solid red'
                        : '1px solid #168384'
                    }"
                  ></nz-date-picker>
                </span>
                <i
                  nz-icon
                  nzType="exclamation-circle"
                  nzTheme="outline"
                  style="color: red"
                  *ngIf="inValidCustomDate"
                >
                </i>
              </label>
            </nz-radio-group>
          </li>
        </div>
      </div>
      <li nz-menu-divider></li>
      <li class="buttons">
        <div class="err-msg-holder" *ngIf="invalidDataview">
          <i
            nz-icon
            nzType="exclamation-circle"
            nzTheme="outline"
            style="color: red"
          ></i>
          <span class="err-msg">{{ dvErrMsg }}</span>
        </div>
        <div class="button-container">
          <button nz-button class="btn" (click)="onResetDataView()">
            Reset
          </button>
          <button nz-button nzType="primary" (click)="applyDataView()">
            Apply
          </button>
        </div>
      </li>
    </ul>
  </ng-template>
</div>
